import React, { Component } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding: ${props => (props.viewPadding ? props.viewPadding : '40px 30px 0px')};
  margin: ${props => (props.viewMargin ? props.viewMargin : '0')};
  height: ${props => (props.height ? props.height : '100%')};
  @media (min-width: 375px) {
    padding: ${props => (props.modifyPadding ? props.modifyPadding : props.viewPadding)};
  }
`
class PageWrapper extends Component {
  render() {
    const { viewPadding, viewMargin, children, modifyPadding, ...props } = this.props
    return (
      <Wrapper viewPadding={viewPadding} viewMargin={viewMargin} modifyPadding={modifyPadding} {...props}>
        {children}
      </Wrapper>
    )
  }
}

export default PageWrapper



// WEBPACK FOOTER //
// ./src/components/PageWrapper.js